// import React from 'react';
// import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
// import Card from 'components/card/Card.js';

// import BarChart from 'components/charts/BarChart';
// import ReactApexChart from "react-apexcharts";

// export default function Conversion(props) {
//     const { ...rest } = props;

//     // Chakra Color Mode
//     const cardColor = useColorModeValue('white', 'navy.700');
//     const cardShadow = useColorModeValue(
//         '0px 18px 40px rgba(112, 144, 176, 0.12)',
//         'unset'
//     );

//     const state = {
//         series: [
//           {
//             name: 'Top half',
//             data: [5, 4, 3, 2, 1,null, null,null, null,null]
//           },
//           {
//             name: 'Bottom half',
//             data: [null, null, null, null, null,-1,-2,-3,-4,-5]
//           },
//         ],
//         options: {
//           chart: {
//             type: 'bar',
//             height: 350,
//             stacked: false,
//             toolbar: {
//               show: true,
//             },
//           },
//           title: {
//             text: 'Enrichment Pathways',  // Your title goes here
//             align: 'center',
//             margin: 20,
//             style: {
//               fontSize: '20px',
//               fontWeight: 'bold',
//             },
//           },
//           plotOptions: {
//             bar: {
//               horizontal: true,
//               dataLabels: {
//                 position: 'bottom'
//               },
//             },
//           },
//           xaxis: {
//             categories: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
//             axisBorder: {
//               show: true,
//               color: '#78909C',
//               height: 1,
//               width: '100%',
//               offsetX: +130,
//               offsetY: 0
//             },
//           },
//           yaxis: {
//             show: false
//           },
//         },
//       };



//     return (
//         <Card p='20px' align='center' direction='column' w='100%' {...rest}>


//             <Flex direction='row' py='5px' me='10px'>

//                 <div id="chart">
//                 <ReactApexChart options={state.options} series={state.series} type="bar" height={350} />
//                 </div>
//             </Flex>
//         </Card>
//     );
// }
// import React from 'react';
// import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
// import Card from 'components/card/Card.js';
// import ScatterPlot from 'components/charts/ScatterChart';

// export default function Conversion(props) {
//     const { ...rest } = props;

//     // Chakra Color Mode
//     const cardColor = useColorModeValue('white', 'navy.700');
//     const cardShadow = useColorModeValue(
//         '0px 18px 40px rgba(112, 144, 176, 0.12)',
//         'unset'
//     );

//     const chartOptions = {
//         chart: {
//             id: "basic-scatter-plot",
//             toolbar: {
//                 show: false,
//             },
//             offsetX: +0,
//         },
//         title: {
//             text: 'Volcano',
//             align: 'center',
//             margin: 20,
//             style: {
//                 fontSize: '24px'
//             }
//         },

//         xaxis: {
//             type: 'numeric', // 'numeric' or 'datetime' or 'category'
//             tickAmount: 10,  // Number of ticks to show on x-axis
//             // min: 1990,          // Minimum value
//             // max: 2000,        // Maximum value
//             title: {
//                 text: "log2 Fold Change"
//             },
//             tickPlacement: 'on'
//         },
//         yaxis: {
//             title: {
//                 text: "-log10(FDR)"
//             },
//             type: 'numeric', // 'numeric' or 'datetime' or 'category'
//             tickAmount: 10,  // Number of ticks to show on x-axis
//             tickPlacement: 'on'

//         },
//         annotations: {
//             xaxis: [
//               {
//                 x: 0,
//                 borderColor: '#999',
//                 yAxisIndex: 0,
//                 label: {
//                   show: false
//                 }
//               },
//               {
//                 x: -1,
//                 strokeDashArray: 5,
//                 borderColor: '#000000',
//                 label: {
//                   borderColor: '#000000',
//                   style: {
//                     color: '#000000',
//                     background: '#FFFFFF',
//                   },
//                 //   text: 'x = -1',
//                 },
//               },
//               {
//                 x: 1,
//                 strokeDashArray: 5,
//                 borderColor: '#000000',
//                 label: {
//                   borderColor: '#000000',
//                   style: {
//                     color: '#000000',
//                     background: '#FFFFFF',
//                   },
//                 //   text: 'x = 1',
//                 },
//               }
//             ],
//             yaxis: [
//                 {
//                   y: 2,
//                   borderColor: '#999',
//                   label: {
//                     show: false
//                   }
//                 }
//               ]
//           },
          
//         markers: {
//             size: 6
//         }
//     };

//     const chartData = [
//         {
//             name: "Up",
//             data: [[1.991, 3], [1.992, 10], [1.993, 13], [1.994, 15]],
//             color: '#FFCCCC'
//         },
//         {
//             name: "Down",
//             data: [[-1.992, 4], [-1.992, 7], [-1.993, 7], [-1.994, 7]],
//             color: '#CCCCFF'
//         },
//         {
//             name: "Sig-Up",
//             data: [[3, 4], [5, 7], [4, 7], [2.1, 7]],
//             color: '#FF0000'
//         },
//         {
//             name: "Sig-down",
//             data: [[-2, 4], [-3, 7], [-4, 7], [-3.5, 7]],
//             color: '#0000FF'
//         },
//         {
//             name: "NS",
//             data: [[-0.1, 1], [-0.2, 1], [0.2, 1], [0.1, 1]],
//             color: '#808080'
//         }
//     ];

//     return (
//         <Card p='20px' align='center' direction='column' w='100%' {...rest}>


//             <Flex direction='row' py='5px' me='10px'>

//                 <ScatterPlot chartOptions={chartOptions} chartData={chartData} />


//             </Flex>
//         </Card>
//     );
// }


import React, { useState, useEffect } from 'react';
import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card.js';

import axios from 'axios';

export default function Conversion(props) {
    const { ...rest } = props;

    // Chakra Color Mode
    const cardColor = useColorModeValue('white', 'navy.700');
    const cardShadow = useColorModeValue(
        '0px 18px 40px rgba(112, 144, 176, 0.12)',
        'unset'
    );

    const [imageBase64, setImageBase64] = useState("");
    const [error, setError] = useState(null); // Initialize error state

    useEffect(() => {
        // Check if selectedOption is not null and has a value field
        if (props.selectedOption && props.selectedOption.value) {
            // Use the selectedOption.value in the API URL
            const api_host = "http://glycopeptideatlas-eb-env.eba-zxebtsmp.us-west-2.elasticbeanstalk.com"
            const apiUrl = `${api_host}/api/get-diff-kegg-image/?project=${props.selectedOption.value}`;

            axios.get(apiUrl)
                .then(response => {
                    setImageBase64(response.data.image_base64);
                })
                .catch(err => {
                    setError("Failed to fetch image."); // Set error state
                    console.error("Error fetching image: ", err);
                });
        }
    }, [props.selectedOption]);

    return (
        <Card p='20px' align='center' direction='column' w='100%' {...rest}>
            <div className="App">
                <Box mb={4}>
                    <h3>Concordantly regulated phosphoprotein and glycoprotein pairs in oncogenic transition</h3>
                </Box>
                {imageBase64 && <img src={`data:image/jpeg;base64,${imageBase64}`} alt="description" />}
                {error && <p>{error}</p>} {/* Display error message */}
            </div>
        </Card>
    );
}
